/** Anzeige-Formatierung. Pure, damit sie getestet werden kann. */

/** Euro im deutschen Format: `29.95` → `29,95 €`. Leer bleibt ein Gedankenstrich. */
export function euro(wert: number | null | undefined): string {
  if (wert == null || !Number.isFinite(wert)) return '–';
  return `${wert.toFixed(2).replace('.', ',')} €`;
}

/** Ganze Zahl mit Tausenderpunkt. */
export function zahl(wert: number | null | undefined): string {
  if (wert == null || !Number.isFinite(wert)) return '–';
  return wert.toLocaleString('de-DE');
}

/** Prozent ohne Nachkommastelle: `40` → `40 %`. */
export function prozent(wert: number | null | undefined): string {
  if (wert == null || !Number.isFinite(wert)) return '–';
  return `${wert.toLocaleString('de-DE', { maximumFractionDigits: 1 })} %`;
}

/** Dateigroesse in MB, eine Nachkommastelle. */
export function megabyte(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes)) return '–';
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

/** ISO-Zeitstempel als `11.09.2026, 14:39`. */
export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return '–';
  const datum = new Date(iso);
  if (Number.isNaN(datum.getTime())) return '–';
  return datum.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Gemini-Kosten in US-Dollar — die Vertex-Abrechnung läuft in USD, ein Umrechnungskurs
 * wäre geraten. Unter 10 Cent mit drei Nachkommastellen, sonst zwei.
 */
export function usd(wert: number | null | undefined): string {
  if (wert == null || !Number.isFinite(wert)) return '–';
  const stellen = Math.abs(wert) < 0.1 ? 3 : 2;
  return `${wert.toLocaleString('de-DE', { minimumFractionDigits: stellen, maximumFractionDigits: stellen })} $`;
}
